var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumns2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.3499999 6.35",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.132292
    },
    id: "rect2",
    width: 1.4552081,
    height: 4.1010413,
    x: 1.1244793,
    y: 1.1244793
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.132292
    },
    id: "rect3",
    width: 1.4552081,
    height: 4.1010413,
    x: 3.7703125,
    y: 1.1244793
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns2);
export default __webpack_public_path__ + "static/media/columns_2.7de564042a1154883b43a0e0762eded2.svg";
export { ForwardRef as ReactComponent };